'use client';

import { useEffect } from 'react';
import { usePathname } from 'next/navigation';
import {
  loadAwinTrackingScript,
  getAwinMerchantId,
  setAwinAdvertiserConsent
} from '@/util/awin_client';
import { useCookieConsent } from '@/components/hook/cookie-consent';

const PAYMENT_PATHS = [
  '/myaccount/payment',
  '/account/payment',
  '/cart/checkout',
  '/cart/confirmation',
  '/apply/billing'
];

/**
 * AWIN MasterTag Component
 * Loads the AWIN click tracking script on all pages except payment pages.
 *
 * The MasterTag is loaded regardless of cookie consent so that the `awc`
 * cookie can be set immediately when consent is granted (no page refresh
 * required). Awin's `AdvertiserConsent` flag controls whether the script
 * actually writes the first-party cookie.
 */
export default function AwinMasterTag() {
  const pathname = usePathname();
  const consent = useCookieConsent();

  useEffect(() => {
    const merchantId = getAwinMerchantId();
    if (!merchantId) return;

    const isPaymentPage = PAYMENT_PATHS.some(
      (path) => pathname?.startsWith(path)
    );
    if (isPaymentPage) return;

    setAwinAdvertiserConsent(consent.advertisement);
    loadAwinTrackingScript(merchantId);
    // consent.advertisement intentionally excluded — the effect below
    // propagates consent changes without re-running load logic.
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [pathname]);

  useEffect(() => {
    setAwinAdvertiserConsent(consent.advertisement);
  }, [consent.advertisement]);

  return null;
}
